import React from 'react'
import classNames from 'classnames'
import * as styles from './GitHubButton.module.scss'
const GITHUB_PATH = 'https://github.com/hetzneronline/community-content'

/*
View file on GitHub
`${GITHUB_PATH}/blob/master/tutorials/${frontmatter.github_path}`
Edit file on GitHub
`${GITHUB_PATH}/edit/master/tutorials/${frontmatter.github_path}`
Create new issue
`${GITHUB_PATH}/issues/new?title=${frontmatter.title}&body=${issueBody}`
*/

export const GitHubButton = ({ frontmatter, className }) => {
  const issueBody = '%23%23%20Problem%0A%0A%23%23%20Suggested%20Fix'
  return (
    <a
      className={classNames('link-unstyled drop-shadow-none', className)}
      target={'_blank'}
      href={`${GITHUB_PATH}/issues/new?title=${frontmatter.title}&body=${issueBody}`}
      rel={'noopener noreferrer'}
    >
      <div className={styles.wrapper} style={{ marginTop: 14 }}>
        <span className={'align-self-center'}>
          <i className='fa fa-github mr-1' /> Report Issue
        </span>
      </div>
    </a>
  )
}
